(function(){
    "use strict";

    angular
        .module('ccsTrApp')
        .service('GrowthCustomService', GrowthCustomService);

    GrowthCustomService.$inject = ['$http'];

    function GrowthCustomService($http) {
        var service = {
            returnAllGrowths: returnAllGrowths,
            returnParentGrowths: returnParentGrowths
        };

        return service;

        function returnAllGrowths() {
            var url = "api/growths/all";
            return $http.get(url);
        }

        function returnParentGrowths() {
            var url = "api/growths/parent";
            return $http.get(url);
        }
    }
})();
